var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNumpy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.3201 27.1641L33.3041 16.5591L10.2261 28.0711L31.8201 38.9111L54.3201 27.1641ZM63.9611 32.0311L86.0001 43.1601L63.1371 54.6371L41.5121 43.7821L63.9611 32.0311ZM93.3981 16.7151L116.043 28.0701L95.7891 38.2381L73.7071 27.0971L93.3981 16.7151ZM83.6521 11.8241L63.2651 1.60107L43.1011 11.6671L64.1091 22.2571L83.6521 11.8241ZM67.7151 99.6051V127.421L92.4101 115.097L92.3871 87.2691L67.7151 99.6051ZM92.3751 77.5551L92.3481 50.0201L67.7151 62.2661V89.8131L92.3751 77.5551ZM122.02 72.3981V100.324L100.954 110.832L100.938 83.0351L122.02 72.3981ZM122.02 62.6331V35.2661L100.915 45.7581L100.931 73.3481L122.02 62.6331Z",
    fill: "#4CABCF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9961 62.266L42.3671 53.899V90.039C42.3671 90.039 22.0191 46.756 20.1401 42.865C19.8981 42.361 18.8981 41.814 18.6441 41.677C14.9761 39.763 4.28906 34.353 4.28906 34.353V98.224L19.0741 106.15V72.75C19.0741 72.75 39.2031 111.426 39.4101 111.852C39.6201 112.274 41.6291 116.344 43.7931 117.778C46.6631 119.684 58.9881 127.094 58.9881 127.094L58.9961 62.266Z",
    fill: "#4C75CF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumpy);
export default __webpack_public_path__ + "static/media/numpy.151963a37ac513a4236d3cc226a1b1a7.svg";
export { ForwardRef as ReactComponent };